import { ToggleButton, ToggleButtonGroup } from '@chronosphereio/chrono-ui';
import { ModeOption } from '@/core';

export const MODE_TOGGLE_HEIGHT = 40;

interface ModeToggleProps {
  mode?: ModeOption;
  onChangeMode?: (mode?: ModeOption) => void;
}

export const ModeToggle = ({ mode, onChangeMode }: ModeToggleProps) => {
  return (
    <ToggleButtonGroup value={mode} onChange={(_, value) => onChangeMode?.(value)} sx={{ marginBottom: 1 }}>
      <ToggleButton value="percentage">Percentage</ToggleButton>
      <ToggleButton value="value">Value</ToggleButton>
    </ToggleButtonGroup>
  );
};
